// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__4b3K6","list":"App_list__QPUZk","button":"App_button__RAQgb"};